import styled from "styled-components";

export const Container = styled.div`
  padding: 20px;
  overflow-y: auto;
  height: calc(100% - 40px);
`;

export const Section = styled.div`
  margin-bottom: 30px;
`;

export const SectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 15px;
`;

// Day selector styles
export const DayRow = styled.div`
  display: flex;
  align-items: center;
  margin: 10px 0;
  opacity: ${props => (props.selected ? 1 : 0.5)};
`;

export const DayLabel = styled.div`
  font-weight: 500;
  width: 120px;
  margin-left: 10px;
`;

export const SelectWrapper = styled.div`
  flex: 1;
  max-width: 300px;
`;

export const DividerContainer = styled.div`
  margin: 20px 0 10px;
`;

// Weekly hours styles
export const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
`;

// Button container
export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
`;

export const StatusMessage = styled.div`
  margin-top: 15px;
  padding: 10px;
  border-radius: 5px;
  text-align: center;
  color: ${props => (props.success ? "#4caf50" : "#f44336")};
  background-color: ${props => (props.success ? "#e8f5e9" : "#ffebee")};
  display: ${props => (props.visible ? "block" : "none")};
`;
